import React, { useState } from 'react';
import TempltList from './TempltList';
import AddUpdateTempletPopup from './AddUpdateTempletPopup';
import { post } from '../Auths/AuthToken';
import setUiMessage from '../../Utilities/Tostify';
import ConfirmDialog from '../../Utilities/ConfirmDialog';
import { useSelector } from 'react-redux';

function TreatTemletList({ listArr, apiCallFun, name }) {
  const { user } = useSelector((state) => state.auth);
  const [searchQuery, setSearchQuery] = useState('');
  const [addUpdatePopup, setAddUpdatePopup] = useState(false);
  const [allData, setAllData] = useState(listArr);
  const [templetId, setTempletId] = useState();

  const [removeSubChild, setRemoveSubChild] = useState(false);
  const [sucPrams, setSucPrams] = useState('');

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };
  let filteredList = allData?.filter((data) =>
    data?.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleAddNewTemplet = () => {
    setAddUpdatePopup(true);
    setTempletId('');
  };

  const saveTemletData = (id, title, text) => {
    (async () => {
      let response;
      try {
        if (id) {
          response = await post(
            'api/patient/treatmentPlan/mhtpTempletPopupUpdate',
            {
              id: id,
              type: name,
              title: title,
              description: text,
              staffUserId: user?.id,
              userType: user?.user_type,
            }
          );
        } else {
          response = await post(
            'api/patient/treatmentPlan/mhtpTempletPopupSave',
            {
              type: name,
              title: title,
              description: text,
              staffUserId: user?.id,
              userType: user?.user_type,
            }
          );
        }

        if (response.status === 200) {
          if (response?.data.templetArrs.length > 0) {
            setAllData(
              response?.data?.templetArrs.map((data) => {
                return { id: data?.id, label: data?.label };
              })
            );
          }
          setAddUpdatePopup(false);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  const handleTempletEdit = (id, name) => {
    setAddUpdatePopup(true);
    setTempletId(id);
  };

  const handleTempletDelete = (id, name) => {
    setRemoveSubChild(true);
    setTempletId('');
    setSucPrams(id);
  };

  const handleTempletDeleteConfirm = (id) => {
    (async () => {
      try {
        let response = await post(
          'api/patient/treatmentPlan/mhtpTempletListDeleteConfirm',
          {
            id: id,
            type: name,
            staffUserId: user?.id,
            userType: user?.user_type,
          }
        );

        if (response.status === 200) {
          if (response?.data.templetArrs.length > 0) {
            setAllData(
              response?.data?.templetArrs.map((data) => {
                return { id: data?.id, label: data?.label };
              })
            );
          }
          setRemoveSubChild(false);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  };

  return (
    <div className="dx-bloc-tmplt-lt grid-sec">
      <span className="search-Tmplate-sec">
        <input
          type="search"
          className="inpt-width-nw"
          placeholder="Search template"
          value={searchQuery}
          onChange={handleSearchChange}
        />
      </span>
      <ul>
        {filteredList &&
          filteredList.map((data, i) => {
            return (
              <TempltList
                key={i}
                data={data}
                apiCallFun={apiCallFun}
                editFun={handleTempletEdit}
                delFun={handleTempletDelete}
                name={name}
              />
            );
          })}
      </ul>
      <span
        className="add-Tmplate-sec link-color center"
        onClick={handleAddNewTemplet}
      >
        Add New template
      </span>
      {addUpdatePopup && (
        <AddUpdateTempletPopup
          name={name}
          handleClose={() => setAddUpdatePopup(false)}
          handleSaveUpdate={saveTemletData}
          templetId={templetId}
        />
      )}
      {removeSubChild && (
        <ConfirmDialog
          bodytext={'Do you want to remove it?'}
          closeDialog={() => setRemoveSubChild(false)}
          successDialog={handleTempletDeleteConfirm}
          sucPrams={sucPrams}
        />
      )}
    </div>
  );
}

export default TreatTemletList;
